import React from "react";

import "./index.scss";

const ListViewIcon = ({ isActive }) => {
  const style = isActive ? "list-view-icon--active" : "";
  return (
    <svg id="List" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className={`list-view-icon--container ${style}`}>
      <g id="Group_10899" data-name="Group 10899">
        <path id="Path_9295" data-name="Path 9295" d="M0,0H32V32H0ZM0,0H32V32H0Z" fill="none" />
        <path
          className="list-view-icon"
          id="Path_9296"
          data-name="Path 9296"
          d="M24,10.167H12v1.666H24ZM9.633,10.2h-1.6v1.6h1.6ZM24,15.167H12v1.666H24ZM9.633,15.2h-1.6v1.6h1.6ZM24,20.167H12v1.666H24ZM9.633,20.2h-1.6v1.6h1.6Z"
        />
      </g>
    </svg>
  );
};

export default ListViewIcon;
